// Portuguese (PT-PT) — AI-prepared, pending native review before production.
// Keys override the English master copy carried as component defaults.
export default {
  // SEO
  "seo.title": "Abra o Seu Ginásio — Equipamento Direto da Fábrica | YANRE FITNESS EUROPE",
  "seo.description": "Do estúdio privado à grande unidade comercial — equipamento profissional YANRE, consultoria de projeto personalizada, logística internacional e pós-venda com garantia de fábrica.",

  // Header / nav
  "nav.Why Fitness": "Porquê Fitness",
  "nav.Why YANRE": "Porquê a YANRE",
  "nav.How It Works": "Como Funciona",
  "nav.Real Projects": "Projetos Reais",
  "nav.visitWebsite": "Visitar Website",
  "header.cta": "Começar o Seu Projeto",

  // Hero
  "hero.label": "Abra o Seu Ginásio",
  "hero.line1": "Construa o seu ginásio.",
  "hero.line2a": "Compre diretamente ao",
  "hero.line2b": "fabricante.",
  "hero.copy": "De estúdios privados a grandes unidades comerciais — equipamento profissional YANRE, consultoria de projeto personalizada, apoio logístico internacional e pós-venda com garantia de fábrica.",
  "hero.ctaPrimary": "Começar o Meu Projeto de Ginásio",
  "hero.ctaSecondary": "Falar com um Especialista",
  "hero.trust.0": "Direto da Fábrica",
  "hero.trust.1": "Consultoria de Projeto",
  "hero.trust.2": "Logística Internacional",
  "hero.trust.3": "Garantia de Fábrica",

  // Marquee
  "marquee.Precision": "Precisão",
  "marquee.Performance": "Performance",
  "marquee.Confidence": "Confiança",
  "marquee.Engineering": "Engenharia",
  "marquee.Since 1997": "Desde 1997",

  // CTA strips
  "strip.1": "Pronto para falar sobre o seu projeto?",
  "strip.2": "Sabe do que precisa? Vamos falar.",
  "strip.3": "Viu o suficiente? Comece o seu projeto.",
  "strip.cta": "Começar o Seu Projeto",

  // Section labels (SectionLabel children as keys)
  "label.Why Invest in Fitness": "Porquê Investir em Fitness",
  "label.Fitness Market Proof": "Prova do Mercado de Fitness",
  "label.New to Fitness? That's OK.": "Novo no Fitness? Não Há Problema.",
  "label.Factory Direct": "Direto da Fábrica",
  "label.Factory Direct Purchase Process": "Processo de Compra Direto da Fábrica",
  "label.Featured Equipment": "Equipamento em Destaque",
  "label.Engineered Differently": "Engenharia Diferente",
  "label.Built Around Your Business": "Construído à Volta do Seu Negócio",
  "label.Why YANRE FITNESS": "Porquê a YANRE FITNESS",
  "label.The Founder": "O Fundador",
  "label.YANRE Gyms Around the World": "Ginásios YANRE pelo Mundo",
  "label.International Logistics": "Logística Internacional",
  "label.After-Sales & Warranty": "Pós-Venda e Garantia",
  "label.Start Your Project": "Comece o Seu Projeto",
  "label.Milestones": "Marcos",
  "label.Engineering Philosophy": "Filosofia de Engenharia",

  // WhatsApp
  "wa.title": "WhatsApp",
  "wa.subtitle": "Falar com um Especialista",

  // Footer
  "footer.contact": "Contacto",
  "footer.legal": "Legal",
  "footer.privacy": "Política de Privacidade",
  "footer.cookies": "Política de Cookies",
  "footer.terms": "Termos",
  "footer.visit": "Visitar o Website YANRE FITNESS EUROPE",

  // Form — steps
  "step.1": "Projeto",
  "step.2": "Espaço",
  "step.3": "Investimento",
  "step.4": "Contacto",
  "step.5": "Necessidades do Projeto",
  "step.6": "Logística",
  "step.7": "Compra",
  "step.8": "O Seu Papel",
  "step.9": "Localização",
  "step.10": "Contacto",
  "step.11": "Informação Final",
  "form.progress": "Passo",
  "form.title1": "Construa o projeto",
  "form.title2": "do seu ginásio.",
  "form.subtitle": "Diga-nos o que está a planear. Ajudamo-lo a construir a solução de equipamento certa.",
  "form.intro.sub1": "4 PASSOS RÁPIDOS.",
  "form.intro.sub2": "UMA SOLUÇÃO COMPLETA PARA O SEU GINÁSIO.",
  "form.intro.support": "Fale-nos do seu projeto em apenas 4 passos simples. A nossa equipa vai compreender as suas necessidades e ajudá-lo a construir a solução certa — com fornecimento direto de fábrica da YANRE FITNESS China, consultoria profissional e apoio pós-venda.",
  "form.intro.minute": "1 MINUTO PARA CONCLUIR",
  "form.back": "Voltar",
  "form.continue": "Continuar",
  "form.submit": "Receber o Meu Projeto de Ginásio",
  "form.sending": "A enviar…",

  // Form — questions
  "q.projectType": "O que melhor descreve o seu projeto?",
  "q.franchiseStatus": "Já está associado a uma franquia de fitness?",
  "q.locationStatus": "Já tem um espaço para o projeto?",
  "q.facilityArea": "Qual é a área útil aproximada disponível?",
  "q.projectStage": "Em que fase está o seu projeto?",
  "q.openingTimeline": "Quando planeia inaugurar o seu projeto?",
  "q.investmentBand": "Qual é a sua faixa de investimento estimada? (USD)",
  "q.investmentHint": "Uma estimativa é suficiente. Ajuda-nos a recomendar a solução certa para o seu projeto.",
  "q.projectNeed": "Do que precisa para o seu projeto?",
  "q.projectNeedHint": "Selecione todas as opções aplicáveis.",
  "q.equipmentListStatus": "Já tem uma lista de equipamento?",
  "q.logisticsPreference": "Como pretende tratar da logística internacional?",
  "q.purchaseMethod": "Como planeia atualmente comprar o seu equipamento?",
  "q.competitorComparison": "Está atualmente a comparar outras marcas de equipamento?",
  "q.competitorBrands": "Que marcas está a considerar?",
  "q.decisionRole": "Qual é o seu papel neste projeto?",
  "q.country": "País do Projeto",
  "q.city": "Cidade",
  "q.firstName": "Nome Próprio",
  "q.lastName": "Apelido",
  "q.company": "Empresa / Nome do Ginásio (opcional)",
  "q.email": "Endereço de Email",
  "q.phone": "WhatsApp / Telefone",
  "q.preferredContact": "Método de Contacto Preferido",
  "q.notes": "Há mais alguma coisa que devamos saber sobre o seu projeto?",
  "q.optional": "Opcional",
  "q.selectCountry": "Selecionar país",

  // Form — option labels (canonical values unchanged)
  "opt.commercial-gym": "Projeto de Ginásio Completo",
  "opt.boutique-gym": "Ginásio Boutique",
  "opt.pt-studio": "Estúdio de Personal Training",
  "opt.home-gym": "Ginásio Privado em Casa",
  "opt.residential-gym": "Ginásio de Condomínio / Residencial",
  "opt.hotel-resort": "Fitness de Hotel / Resort",
  "opt.corporate-gym": "Ginásio Corporativo",
  "opt.sports-facility": "Instalação Desportiva / de Performance",
  "opt.franchise": "Franchising de Ginásio",
  "opt.other": "Outro",
  "opt.own-franchise": "Sim — já sou dono / opero uma franquia",
  "opt.acquiring-franchise": "Sim — estou a adquirir uma franquia",
  "opt.evaluating-franchise": "Estou a avaliar oportunidades de franquia",
  "opt.independent": "Não — estou a explorar o negócio de fitness de forma independente",
  "opt.confirmed": "Sim — localização confirmada",
  "opt.negotiating": "A negociar uma localização",
  "opt.looking": "Ainda à procura de localização",
  "opt.up-to-100": "Até 100 m²",
  "opt.100-250": "100–250 m²",
  "opt.250-500": "250–500 m²",
  "opt.500-1000": "500–1.000 m²",
  "opt.1000-2000": "1.000–2.000 m²",
  "opt.2000-plus": "2.000+ m²",
  "opt.exploring": "A explorar oportunidades de investimento",
  "opt.initial-planning": "Planeamento inicial",
  "opt.business-plan": "Plano de negócios / Planeamento de investimento",
  "opt.location-selected": "Localização selecionada",
  "opt.architecture": "Arquitetura / Design",
  "opt.construction": "Construção / Renovação",
  "opt.ready-to-purchase": "Pronto para comprar equipamento",
  "opt.expansion": "Abertura de nova unidade / Expansão",
  "opt.within-2": "Dentro de 2 meses",
  "opt.2-4": "2–4 meses",
  "opt.4-6": "4–6 meses",
  "opt.6-12": "6–12 meses",
  "opt.12-plus": "12+ meses",
  "opt.up-to-50k": "Menos de USD 50.000",
  "opt.50-150k": "USD 50.000–150.000",
  "opt.150-300k": "USD 150.000–300.000",
  "opt.300-500k": "USD 300.000–500.000",
  "opt.500k-1m": "USD 500.000–1M",
  "opt.1m-plus": "Mais de USD 1M",
  "opt.complete-equipment": "Equipamento de Ginásio Completo",
  "opt.strength": "Equipamento de Musculação",
  "opt.cardio": "Equipamento de Cardio",
  "opt.full-project-help": "Preciso de ajuda com o projeto completo",
  "opt.have-list": "Sim — já tenho uma lista de equipamentos",
  "opt.need-review": "Parcialmente — tenho uma seleção inicial",
  "opt.need-list": "Não — preciso da ajuda da YANRE",
  "opt.yanre-coordination": "Quero coordenação de logística YANRE",
  "opt.own-partner": "Já tenho um parceiro de logística",
  "opt.compare-both": "Quero comparar ambas as opções",
  "opt.need-guidance": "Preciso de orientação antes de decidir",
  "opt.direct": "Diretamente ao fabricante",
  "opt.dealer": "Revendedor local de equipamento de fitness",
  "opt.distributor": "Distribuidor / Importador",
  "opt.comparing": "A comparar diferentes opções de compra",
  "opt.researching": "Ainda a pesquisar fornecedores",
  "opt.yes": "Sim",
  "opt.no": "Não",
  "opt.owner": "Dono / Fundador",
  "opt.investor": "Investidor",
  "opt.partner": "Sócio",
  "opt.director": "Diretor / Executivo",
  "opt.manager": "Gestor de Ginásio",
  "opt.procurement": "Compras / Procurement",
  "opt.architect": "Arquiteto / Designer",
  "opt.consultant": "Consultor",
  "opt.trainer": "Personal Trainer",
  "opt.whatsapp": "WhatsApp",
  "opt.phone": "Chamada Telefónica",
  "opt.email": "Email",

  // Form — validation
  "err.projectType": "Selecione o que planeia construir.",
  "err.franchiseStatus": "Indique a sua situação relativamente a franquias.",
  "err.locationStatus": "Selecione o estado da sua localização.",
  "err.facilityArea": "Selecione a área de fitness aproximada.",
  "err.projectStage": "Selecione a fase do seu projeto.",
  "err.openingTimeline": "Selecione o prazo previsto de abertura.",
  "err.investmentBand": "Selecione o seu investimento estimado em equipamento.",
  "err.projectNeed": "Selecione pelo menos uma necessidade do projeto.",
  "err.equipmentListStatus": "Selecione o estado da sua lista de equipamento.",
  "err.logisticsPreference": "Selecione uma preferência de logística.",
  "err.purchaseMethod": "Selecione o seu plano de compra.",
  "err.competitorComparison": "Diga-nos se está a comparar marcas.",
  "err.decisionRole": "Selecione o seu papel neste projeto.",
  "err.country": "Selecione o país do projeto.",
  "err.city": "Indique a cidade do projeto.",
  "err.firstName": "Indique o seu nome próprio.",
  "err.lastName": "Indique o seu apelido.",
  "err.email": "Indique um endereço de email válido.",
  "err.phone": "Indique o seu número de WhatsApp / telefone.",
  "err.preferredContact": "Selecione o seu método de contacto preferido.",
  "err.privacyConsent": "Por favor aceite o consentimento de privacidade para submeter o seu projeto.",
  "err.submit": "Algo correu mal ao enviar o seu projeto. Por favor tente novamente.",

  // Form — consent & success
  "consent.privacy": "Consinto que a YANRE FITNESS EUROPE trate a minha informação para me contactar sobre este projeto.",
  "consent.marketing": "Também gostaria de receber ocasionalmente novidades e ofertas da YANRE FITNESS EUROPE. (Opcional)",
  "success.title1": "Projeto recebido",
  "success.body": "Obrigado. Um especialista da YANRE FITNESS EUROPE irá analisar o seu projeto e contactá-lo através do seu canal preferido.",
  "success.reference": "Referência",

  // ===== Section copy =====
  "wi.h1a": "À procura do seu próximo negócio?",
  "wi.h1b": "Olhe para o fitness.",
  "wi.fitnessCol": "Negócio de Fitness",
  "wi.retailCol": "Retalho Tradicional",
  "wi.f1": "Mensalidades recorrentes",
  "wi.f2": "Sem inventário de mercadorias",
  "wi.f3": "Sem reposição diária",
  "wi.f4": "Acesso pré-pago / recorrente",
  "wi.f5": "Potencial de operação enxuta",
  "wi.f6": "Gestão digital",
  "wi.f7": "Equipamento = ativo produtivo de longo prazo",
  "wi.r1": "Vender todos os dias",
  "wi.r2": "Stock para gerir",
  "wi.r3": "Compras constantes",
  "wi.r4": "Receita transação a transação",
  "wi.r5": "Operação com inventário",
  "wi.r6": "Mais complexidade operacional",
  "wi.r7": "O inventário tem de estar sempre a rodar",
  "wi.note": "Uma comparação estrutural de modelos de negócio — não um julgamento de outras indústrias.",
  "mp.s1": "Receita do mercado europeu de fitness em 2025",
  "mp.s2": "Membros de clubes de fitness na Europa em 2025",
  "mp.s3": "Crescimento médio global da receita da indústria de fitness em 2024",
  "mp.s4": "Margem EBITDA mediana entre os operadores do estudo de benchmarking da HFA referenciado",
  "mp.opsLabel": "Os grandes operadores estão a expandir",
  "mp.o1": "Membros adicionados pelos 20 maiores operadores da Europa em 2025",
  "mp.o2": "Receita combinada dos 20 maiores operadores da Europa em 2025",
  "mp.o3": "Grandes transações de M&A no fitness europeu em 2025",
  "mp.src": "Fontes: Health & Fitness Association · EuropeActive / Deloitte. Dados de benchmarking da indústria — não constituem garantia de resultados individuais.",
  "nf.h1a": "Não precisa de vir da",
  "nf.h1b": "indústria do fitness.",
  "nf.b1": "Você traz o investimento e a visão de negócio.",
  "nf.b2": "Nós ajudamos a estruturar o lado do equipamento do projeto.",
  "fd.h1a": "Elimine os intermediários.",
  "fd.h1b": "Não o apoio.",
  "fd.tradLabel": "Modelo tradicional",
  "fd.directLabel": "YANRE Direto da Fábrica",
  "fd.t1": "Fabricante",
  "fd.t2": "Distribuidor / Importador",
  "fd.t3": "Revendedor / Retalhista",
  "fd.t4": "Cliente",
  "fd.customer": "Cliente",
  "fd.trust": "O seu contrato de equipamento e os pagamentos são feitos diretamente com a YANRE FITNESS.",
  "fd.supportLabel": "Direto da fábrica não significa estar sozinho",
  "fd.s1": "Consultoria Personalizada",
  "fd.s2": "Orientação Técnica",
  "fd.s3": "Seleção de Equipamento",
  "fd.s4": "Apoio ao Projeto",
  "fd.s5": "Coordenação Logística Opcional",
  "fd.s6": "Apoio Pós-Venda",
  "fd.s7": "Garantia de Fábrica",
  "pp.h1a": "Um processo claro.",
  "pp.h1b": "Do projeto ao pós-venda.",
  "pp.1.t": "Briefing do Projeto",
  "pp.1.b": "O cliente explica o espaço, o conceito, o investimento e o calendário.",
  "pp.2.t": "Consultoria YANRE",
  "pp.2.b": "Seleção de equipamento, orientação técnica e configuração do projeto.",
  "pp.3.t": "Contrato de Fábrica",
  "pp.3.b": "Proposta final e encomenda oficial de equipamento diretamente com a YANRE FITNESS.",
  "pp.4.t": "Pagamento de 30% à Fábrica",
  "pp.4.b": "Sinal padrão pago diretamente à YANRE FITNESS e a encomenda entra em produção.",
  "pp.5.t": "Produção",
  "pp.5.b": "Fabrico e preparação do equipamento.",
  "pp.6.t": "Pagamento de 70% à Fábrica",
  "pp.6.b": "Saldo padrão pago diretamente à YANRE FITNESS após a produção e antes do envio, de acordo com o contrato oficial.",
  "pp.7.t": "Envio Internacional",
  "pp.7.b": "O cliente pode usar o seu próprio operador logístico ou solicitar coordenação logística.",
  "pp.8.t": "Pós-Venda",
  "pp.8.b": "Apoio contínuo e garantia de fábrica após a entrega.",
  "pp.payTitle": "100% dos pagamentos de equipamento são feitos diretamente à YANRE FITNESS.",
  "pp.paySub": "Nenhum pagamento de equipamento é feito a agentes, consultores ou intermediários.",
  "pp.disclaimer": "Estrutura de pagamento padrão apresentada. As condições comerciais e de pagamento finais são definidas no contrato de venda oficial da YANRE FITNESS.",
  "fe.h1a": "Concebido para render.",
  "fe.h1b": "Construído para ser visto.",
  "fe.tagline": "O seu equipamento faz parte da sua marca.",
  "fe.i0.cat": "Musculação Seletorizada",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "Musculação seletorizada projetada para uso profissional diário.",
  "fe.i1.cat": "Plate Loaded",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "Máquinas plate-loaded construídas em torno do movimento natural.",
  "fe.i2.cat": "Dupla Função",
  "fe.i2.series": "C4D Dupla Função",
  "fe.i2.stmt": "Duas estações num só espaço — máxima densidade de treino.",
  "fe.i3.cat": "Cardio Comercial",
  "fe.i3.series": "Cardio Comercial",
  "fe.i3.stmt": "Cardio construído para ambientes comerciais sem parar.",
  "dd.h1a": "A diferença",
  "dd.h1b": "está nos detalhes.",
  "dd.0.t": "Engenharia Original",
  "dd.0.s": "Design desenvolvido pela YANRE.",
  "dd.1.t": "Design Patenteado",
  "dd.1.s": "Design de equipamento original e patenteado.",
  "dd.2.t": "Construção da Estrutura",
  "dd.2.s": "Engenharia de estrutura e tubos em close-up.",
  "dd.3.t": "Design de Estrutura Curva",
  "dd.3.s": "Geometria da estrutura moldada em torno do movimento.",
  "dd.4.t": "Estofos e Almofadas",
  "dd.4.s": "Estofos profissionais, costura e acabamento.",
  "dd.5.t": "Sistema de Cabos / Polias / Guias",
  "dd.5.s": "Componentes de movimento de precisão.",
  "dd.6.t": "Biomecânica",
  "dd.6.s": "Pivôs e trajetórias de movimento desenhados em torno do corpo.",
  "dd.7.t": "Construção de Nível Comercial",
  "dd.7.s": "Construída para durabilidade e uso profissional diário.",
  "bt.0": "Ginásio Comercial",
  "bt.1": "Clube de Fitness Premium",
  "bt.2": "Ginásio Boutique",
  "bt.3": "Estúdio de Personal Training",
  "bt.4": "Ginásio de Força / Performance",
  "bt.5": "Instalação de Treino Funcional",
  "bt.6": "Ginásio Privado Profissional em Casa",
  "bt.7": "Ginásio Residencial / Condomínio",
  "bt.8": "Hotel / Resort",
  "bt.9": "Fitness Corporativo",
  "bt.10": "Local de Franquia",
  "wy.h1a": "Projetado pela experiência.",
  "wy.h1b": "Construído para a performance.",
  "wy.p1.t": "Fabrico",
  "wy.p1.b": "Produção interna de sistemas de musculação de nível comercial — projetados e fabricados pela YANRE, não montados a partir de designs de terceiros.",
  "wy.p2.t": "Engenharia e Biomecânica",
  "wy.p2.b": "Design original desde 1997, com mais de 200 patentes que cobrem engenharia de equipamento e biomecânica de movimento.",
  "wy.p3.t": "Durabilidade Comercial",
  "wy.p3.b": "Equipamento construído para uso profissional diário, certificado segundo as normas CE, TÜV e ISO.",
  "wy.p4.t": "Desenvolvimento de Produto",
  "wy.p4.b": "Uma gama liderada pelo fabricante — da 73 Tough Series às linhas plate-loaded, máquinas de dupla função e cardio comercial.",
  "wy.p5.t": "Experiência Internacional",
  "wy.p5.b": "A confiança de ginásios profissionais em mais de 110 países, com mais de 34.950 projetos de ginásios entregues em todo o mundo.",
  "wy.proof0": "Desde 1997",
  "wy.proof1": "200+ Patentes",
  "wy.proof2": "110+ Países",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "34.950+ Projetos",
  "fo.navFactory": "A Fábrica",
  "fo.navFounder": "O Homem por Trás da Máquina",
  "fo.h1a": "O Homem",
  "fo.h1b": "por Trás",
  "fo.h1c": "da Máquina.",
  "fo.role": "Fundador e Designer-Chefe",
  "fo.body": "Atleta, engenheiro e fundador da YANRE. Desde 1997, constrói máquinas para quem valoriza a engenharia acima do marketing.",
  "fo.quote": "“Para entender a máquina, é preciso entender o homem por trás dela.”",
  "fo.st1.t": "O Início",
  "fo.st1.b": "Em 1991, George Yang ainda não era fundador — era técnico, a reparar máquinas de ginásio para a Seleção Nacional de Atletas da China. Reparar revelou a verdade; ele próprio treinava nas máquinas para sentir exatamente onde falhavam.",
  "fo.st2.t": "O Problema",
  "fo.st2.b": "Mesmo as “melhores” marcas do mundo tinham falhas — soldaduras fracas, ângulos pobres e designs que ignoravam o corpo humano. As limitações que viu moldaram uma forma totalmente diferente de pensar o equipamento.",
  "fo.st3.t": "A Fundação",
  "fo.st3.b": "Em 1997, deixou de corrigir os erros dos outros e definiu o seu próprio padrão — fundando a Yangrui Fitness em Pequim, com o nome do seu filho. O nome evoluiu de Yangrui para Yanre e depois YR; o padrão nunca mudou.",
  "fo.st4.t": "O Engenheiro",
  "fo.st4.b": "Recusa compromissos nos materiais: aço qualificado Q235 com mínimo de 3 mm, barras 30CrMnSiA, cames e polias POM de baixo atrito e cabos importados do Japão com classificação de 1400kg. “Eu próprio treino nestas máquinas.”",
  "fo.st5.t": "O Designer",
  "fo.st5.b": "A sua filosofia é limpa e minimalista — o design não é o aspeto, é o funcionamento. A YANRE projeta em vez de copiar; a 73 Series foi a primeira no mundo a usar trajetórias de movimento independentes, convergentes e divergentes.",
  "fo.st6.t": "A Visão",
  "fo.st6.b": "Uma fábrica de artesãos, não um armazém de caixas — encomenda mínima de uma unidade, personalização real e apoio pensado para o 10.º ano de um ginásio, não apenas para o primeiro dia. Um parceiro, não um chefe.",
  "fo.m1.t": "Experiência Técnica Inicial",
  "fo.m1.b": "Técnico da Seleção Nacional de Atletas da China.",
  "fo.m2.t": "Fundação da YANRE",
  "fo.m2.b": "Yangrui Fitness fundada em Pequim.",
  "fo.m3.t": "A 73 Series",
  "fo.m3.b": "Primeira no mundo com trajetórias independentes, convergentes e divergentes.",
  "fo.pqA": "“Fazemos produtos com",
  "fo.pqHeart": "coração",
  "fo.pqB": ", e fazemos produtos com",
  "fo.pqStandard": "padrão",
  "fo.pqEnd": ".”",
  "fo.c1.t": "Materiais",
  "fo.c1.b": "Aço Q235, mínimo de 3 mm. Cames POM. Cabos de 1400kg.",
  "fo.c2.t": "Biomecânica",
  "fo.c2.b": "Trajetórias de movimento projetadas em torno do corpo humano.",
  "fo.c3.t": "Durabilidade",
  "fo.c3.b": "Construído para durar mais de 10 anos de uso profissional.",
  "fo.c4.t": "Padrão",
  "fo.c4.b": "ISO 20957 como ponto de partida — nunca como teto.",
  "cc.h1a": "Ginásios reais.",
  "cc.h1b": "Negócios reais.",
  "cc.h1c": "YANRE real.",
  "cc.case0.title": "Visual Premium. Instalação Profissional.",
  "cc.case1.title": "Layout Simples. Instalação Sólida.",
  "cc.case2.title": "Estilo Funcional. Equipamento Profissional.",
  "cc.videoPending": "Vídeo completo do projeto disponível mediante pedido",
  "lg.h1a": "O seu equipamento. O seu destino.",
  "lg.h1b": "A sua escolha.",
  "lg.option": "Opção",
  "lg.o1.t": "Use o Seu Parceiro de Logística",
  "lg.o1.b": "Trabalhe com o operador logístico em quem já confia. Preparamos a sua encomenda para exportação e coordenamos com o seu parceiro.",
  "lg.o2.t": "Deixe a Coordenação Connosco",
  "lg.o2.b": "Solicite a coordenação logística YANRE de acordo com o âmbito contratado — da fábrica ao porto de destino.",
  "lg.f1": "Fábrica",
  "lg.f2": "Exportação",
  "lg.f3": "Transporte Marítimo",
  "lg.f4": "Porto de Destino",
  "lg.disclaimer": "Desalfandegamento, impostos, taxas e serviços de última milha só estão incluídos quando explicitamente contratados.",
  "lg.cta": "Incluir Logística no Meu Projeto",
  "as.h1a": "A relação não termina",
  "as.h1b": "quando o contentor parte.",
  "as.1.t": "Garantia de Fábrica",
  "as.1.b": "Apoio de garantia do fabricante para o seu equipamento.",
  "as.2.t": "Apoio Técnico",
  "as.2.b": "Assistência técnica direta, ligada a quem está por trás do equipamento.",
  "as.3.t": "Apoio de Peças",
  "as.3.b": "Apoio de peças ao nível do fabricante para as suas máquinas.",
  "as.4.t": "Assistência Pós-Venda",
  "as.4.b": "Assistência pós-venda contínua após a entrega.",

  // Cookie consent & policy
  "ck.title": "As suas escolhas de privacidade",
  "ck.desc": "Utilizamos cookies opcionais de análise e publicidade apenas com o seu consentimento. Pode alterar ou retirar a sua escolha a qualquer momento.",
  "ck.acceptAll": "Aceitar Tudo",
  "ck.reject": "Rejeitar Não Essenciais",
  "ck.manage": "Gerir Preferências",
  "ck.save": "Guardar Preferências",
  "ck.necessary": "Necessários",
  "ck.necessaryDesc": "Necessários para o funcionamento do website. Sempre ativos.",
  "ck.analytics": "Análise",
  "ck.analyticsDesc": "Estatísticas anónimas de utilização que nos ajudam a melhorar este website.",
  "ck.advertising": "Publicidade",
  "ck.advertisingDesc": "Utilizados para medir campanhas e apresentar publicidade relevante.",
  "ck.alwaysOn": "Sempre ativos",
  "ck.prefsTitle": "Preferências de Cookies",
  "ck.policy": "Política de Cookies",
  "ck.privacy": "Política de Privacidade",
  "footer.cookiePrefs": "Preferências de Cookies",
  "cp.title": "Política de Cookies",
  "cp.updated": "Última atualização: julho de 2026",
  "cp.intro": "Esta página explica como a YANRE FITNESS EUROPE utiliza cookies e tecnologias semelhantes neste website, e como pode controlá-los.",
  "cp.s1t": "O que armazenamos",
  "cp.s1b": "Quando faz uma escolha de consentimento, armazenamos apenas essa escolha (necessários, análise, publicidade) no armazenamento local do seu navegador. Não contém informação pessoal e serve apenas para lembrar a sua preferência entre visitas.",
  "cp.s2t": "Categorias de cookies",
  "cp.s3t": "Google Tag Manager e Modo de Consentimento",
  "cp.s3b": "Este website carrega um contentor Google Tag Manager com o Modo de Consentimento v2 da Google. Todo o armazenamento opcional (análise e publicidade) está definido como \"denied\" por predefinição e só é ativado após o seu consentimento explícito. Nenhuma tag de análise ou publicidade está instalada diretamente neste website.",
  "cp.s4t": "Gerir o seu consentimento",
  "cp.s4b": "Pode alterar ou retirar o seu consentimento a qualquer momento através do link \"Preferências de Cookies\" no rodapé do website. A retirada tem efeito imediato.",
  "cp.s5t": "Contacto",
  "cp.privacyT": "Privacidade",
  "cp.privacyB": "A nossa Política de Privacidade completa está a ser finalizada. Para qualquer questão ou pedido sobre os seus dados pessoais, contacte-nos através do email acima.",
  "cp.back": "Voltar à Página Inicial",

  "q.fullName": "Nome Completo",
  "opt.upgrade-expand": "Renovação / Ampliação de um Ginásio Existente",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — pt-PT =====
  "pts.seo.title": "Estúdio de Personal Trainer — Equipamento de Ginásio Profissional | YANRE FITNESS",
  "pts.seo.description": "Monte o seu estúdio de treino com equipamento profissional YANRE, direto do fabricante. Pacotes iniciais inteligentes, planeamento do espaço e apoio direto da fábrica.",
  "pts.nav.talk": "Falar com um Especialista",
  "pts.header.cta": "Criar o Meu Estúdio",
  "pts.hero.label": "Estúdio de Personal Trainer",
  "pts.hero.line1": "O Seu Estúdio.",
  "pts.hero.line2": "Os Seus Clientes.",
  "pts.hero.line3": "O Seu Negócio.",
  "pts.hero.subhead": "Construa o seu estúdio de treino profissional com a YANRE.",
  "pts.hero.copy": "Do seu primeiro estúdio privado a um espaço premium de personal training — equipamento de ginásio profissional, planeamento inteligente do espaço e apoio direto do fabricante.",
  "pts.hero.ctaPrimary": "Criar o Meu Estúdio",
  "pts.hero.ctaSecondary": "Falar com um Especialista",
  "pts.hero.trust.0": "Qualidade Comercial",
  "pts.hero.trust.1": "Direto do Fabricante",
  "pts.hero.trust.2": "Garantia de Fábrica",
  "pts.hero.trust.3": "Apoio Logístico",
  "pts.journey.label": "A Transição",
  "pts.journey.h2a": "De Personal Trainer",
  "pts.journey.h2b": "a Dono de Estúdio.",
  "pts.journey.copy": "Treinar clientes no ginásio de outra pessoa constrói o negócio dela. O seu próprio estúdio constrói o seu — o seu espaço, as suas relações com os clientes, a sua marca, o seu ativo. A independência começa com uma sala e o equipamento certo.",
  "pts.journey.0": "Personal Trainer",
  "pts.journey.1": "O Seu Próprio Estúdio",
  "pts.journey.2": "Os Seus Próprios Clientes",
  "pts.journey.3": "A Sua Própria Marca",
  "pts.journey.4": "O Seu Próprio Negócio",
  "pts.journey.direct": "Direto do Fabricante.",
  "pts.journey.directCopy": "Construa o seu estúdio com equipamento profissional adquirido diretamente à YANRE — o fabricante que desenvolve e produz cada máquina.",
  "pts.journey.note": "Sem promessas, sem atalhos — apenas a estrutura para transformar o seu ofício num negócio que é seu.",
  "pts.pkg.label": "Duas Formas de Começar",
  "pts.pkg.h2a": "Comece bem.",
  "pts.pkg.h2b": "Cresça ao seu ritmo.",
  "pts.pkg.intro": "Um estúdio profissional começa com um pacote de equipamento cuidadosamente selecionado — e cresce com o tempo. Cada composição é personalizada para o seu espaço, metodologia de treino e nível de investimento.",
  "pts.pkg.tag": "Pacote",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Tudo o que precisa para abrir um estúdio de treino privado e profissional.",
  "pts.pkg.starter.i0": "Primeiro estúdio",
  "pts.pkg.starter.i1": "Personal trainers",
  "pts.pkg.starter.i2": "Espaços pequenos",
  "pts.pkg.starter.i3": "Treino 1-para-3",
  "pts.pkg.starter.i4": "Treino semiprivado",
  "pts.pkg.starter.concept": "Uma combinação cuidadosamente selecionada de máquinas de musculação essenciais, equipamento funcional e pesos livres.",
  "pts.pkg.starter.cta": "Criar o Meu Estúdio Starter",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Uma configuração profissional completa para um negócio premium de personal training.",
  "pts.pkg.studiopro.i0": "Personal trainers estabelecidos",
  "pts.pkg.studiopro.i1": "Estúdios premium",
  "pts.pkg.studiopro.i2": "Maior capacidade de clientes",
  "pts.pkg.studiopro.i3": "Treino em pequenos grupos",
  "pts.pkg.studiopro.i4": "Treino de performance",
  "pts.pkg.studiopro.concept": "Uma combinação mais completa de máquinas de musculação, equipamento funcional, pesos livres e cardio.",
  "pts.pkg.studiopro.cta": "Criar o Meu Studio Pro",
  "pts.pkg.idealFor": "Ideal para",
  "pts.pkg.conceptLabel": "Conceito de equipamento",
  "pts.pkg.quote": "Peça a sua proposta de projeto",
  "pts.pkg.note": "Sem preços fixos online — cada estúdio é orçamentado como um projeto, composto para o seu espaço, metodologia e nível de investimento.",
  "pts.eq.label": "Feito para Treinar a Sério",
  "pts.eq.h2a": "Qualidade comercial.",
  "pts.eq.h2b": "Construído para uso profissional diário.",
  "pts.eq.copy": "As mesmas linhas de equipamento que servem ginásios comerciais — estruturas projetadas, movimento patenteado e durabilidade testada em fábrica — dimensionadas de forma inteligente para um estúdio de treino privado.",
  "pts.eq.strength": "Musculação",
  "pts.eq.functional": "Treino Funcional",
  "pts.eq.freeweights": "Pesos Livres",
  "pts.eq.benches": "Bancos e Racks",
  "pts.eq.cable": "Estações de Cabos",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Equipamento de musculação profissional YANRE para estúdios de personal training",
  "pts.eq.alt.functional": "Equipamento de treino funcional YANRE para estúdios de fitness profissionais",
  "pts.eq.alt.freeweights": "Equipamento profissional de pesos livres YANRE para estúdios de personal training",
  "pts.eq.alt.benches": "Bancos e racks profissionais YANRE para estúdios de personal training",
  "pts.eq.alt.cable": "Estações de cabos profissionais YANRE para estúdios de personal training",
  "pts.eq.alt.cardio": "Equipamento de cardio profissional YANRE para estúdios de personal training",
  "pts.space.label": "Planeamento do Espaço",
  "pts.space.h2a": "O seu espaço.",
  "pts.space.h2b": "O seu projeto.",
  "pts.space.copy": "Não há dois estúdios iguais. A seleção de equipamento e o layout são desenhados à volta da sua realidade — não um pacote fixo de catálogo.",
  "pts.space.f0": "Área útil disponível",
  "pts.space.f1": "Metodologia de treino",
  "pts.space.f2": "Número de clientes em simultâneo",
  "pts.space.f3": "Nível de investimento",
  "pts.space.f4": "Compra Direta de Fábrica",
  "pts.space.f4d": "Equipamento de ginásio profissional YANRE sem camadas desnecessárias de revendedores.",
  "pts.space.f5": "Estúdio Pronto a Operar",
  "pts.space.f5d": "Equipamento profissional, layout inteligente e um conceito de estúdio completo, pronto para o negócio.",
  "pts.space.cta": "Iniciar o Meu Projeto de Estúdio",
  "pts.direct.label": "Direto do Fabricante",
  "pts.direct.h2a": "Sem intermediários.",
  "pts.direct.h2b": "Sem concessões.",
  "pts.direct.copy": "A YANRE é o fabricante — desenvolve e produz o seu próprio equipamento profissional desde 1997. O seu projeto, o seu contrato de equipamento e a sua garantia vivem diretamente com a fábrica que constrói as suas máquinas.",
  "pts.direct.p0": "Equipamento de qualidade comercial",
  "pts.direct.p1": "Relação direta com o fabricante",
  "pts.direct.p2": "Garantia com apoio de fábrica",
  "pts.direct.p3": "Apoio logístico internacional",
  "pts.direct.p4": "Consultoria de projeto",
  "pts.direct.p5": "Apoio pós-venda",
  "pts.process.label": "Como Funciona",
  "pts.process.h2a": "Um processo claro.",
  "pts.process.h2b": "Da ideia ao dia de abertura.",
  "pts.process.1.t": "Consulta",
  "pts.process.1.b": "Compreendemos si, o seu espaço, o seu conceito e o seu nível de investimento.",
  "pts.process.2.t": "Projeto",
  "pts.process.2.b": "Em conjunto, definimos a seleção de equipamento e o layout do estúdio.",
  "pts.process.3.t": "Encomenda — 30%",
  "pts.process.3.b": "Confirme o projeto e inicie a produção com um pagamento de 30% à fábrica.",
  "pts.process.4.t": "Produção",
  "pts.process.4.b": "A YANRE fabrica e prepara o seu equipamento.",
  "pts.process.5.t": "70% Antes do Envio",
  "pts.process.5.b": "O valor restante é liquidado antes do envio, conforme o contrato oficial.",
  "pts.process.6.t": "Envio",
  "pts.process.6.b": "Logística internacional coordenada para o seu projeto.",
  "pts.process.7.t": "Pós-Venda",
  "pts.process.7.b": "Apoio com garantia de fábrica após a instalação.",
  "pts.monetize.label": "Monetize as Horas Livres do Estúdio",
  "pts.monetize.h2a": "Faça o seu estúdio trabalhar",
  "pts.monetize.h2b": "mesmo quando não está.",
  "pts.monetize.copy": "O seu estúdio não tem de gerar valor apenas quando treina os seus próprios clientes. As horas livres podem tornar-se uma oportunidade de receita adicional, dando a outros Personal Trainers acesso ao seu espaço de treino profissional.",
  "pts.monetize.clients": "Os Seus Clientes",
  "pts.monetize.clientsSub": "As suas próprias sessões de treino",
  "pts.monetize.hours": "Horas Disponíveis",
  "pts.monetize.hoursSub": "Outros treinadores usam o seu estúdio",
  "pts.monetize.revenue": "Mais Uma Fonte de Receita",
  "pts.monetize.revenueSub": "Aproveite melhor o seu espaço ao longo do dia",
  "pts.monetize.closeA": "O estúdio é seu.",
  "pts.monetize.closeB": "A agenda é sua.",
  "pts.form.label": "Inicie o Seu Projeto de Estúdio",
  "pts.form.h2a": "Fale-nos do",
  "pts.form.h2b": "seu estúdio.",
  "pts.form.sub": "Dois minutos. Um especialista responde com uma proposta concreta de equipamento para o seu espaço e orçamento.",
  "pts.form.intro.sub1": "4 PASSOS RÁPIDOS.",
  "pts.form.intro.sub2": "UMA SOLUÇÃO COMPLETA PARA O SEU ESTÚDIO.",
  "pts.form.intro.support": "Fale-nos do seu estúdio em apenas 4 passos simples. A nossa equipa vai compreender as suas necessidades e ajudá-lo a construir a solução certa — com fornecimento direto de fábrica da YANRE FITNESS China, consultoria profissional e apoio pós-venda.",
  "pts.form.intro.minute": "1 MINUTO PARA CONCLUIR",
  "pts.form.progress": "Passo",
  "pts.form.back": "Voltar",
  "pts.form.continue": "Continuar",
  "pts.form.submit": "Receber o Meu Projeto de Estúdio",
  "pts.form.sending": "A enviar…",
  "pts.form.err.step": "Preencha os campos obrigatórios para continuar.",
  "pts.form.err.submit": "Ocorreu um erro ao enviar o seu projeto. Tente novamente.",
  "pts.success.title": "O seu projeto de estúdio foi recebido.",
  "pts.success.body": "Um especialista YANRE irá analisar a sua informação e contactá-lo para falar sobre o seu estúdio, necessidades de equipamento e próximos passos.",
  "pts.success.reference": "Referência",
  "pts.success.cta": "Visitar a YANRE FITNESS",
  "pts.q.areYou": "O que melhor o descreve?",
  "pts.q.planning": "O que está a planear?",
  "pts.q.package": "Que pacote de estúdio lhe interessa?",
  "pts.q.location": "Já tem um espaço?",
  "pts.q.size": "Dimensão aproximada do estúdio:",
  "pts.q.timeline": "Quando planeia inaugurar o seu estúdio?",
  "pts.q.investment": "Qual é o seu orçamento de investimento estimado? (USD)",
  "pts.q.needs": "Do que precisa?",
  "pts.q.needsHint": "Selecione todas as opções aplicáveis.",
  "pts.q.country": "País",
  "pts.q.city": "Cidade",
  "pts.q.fullName": "Nome Completo",
  "pts.q.email": "Email",
  "pts.q.phone": "Telefone / WhatsApp",
  "pts.q.company": "Empresa / Nome do Estúdio (opcional)",
  "pts.q.selectCountry": "Selecione o país",
  "pts.step.1": "Estúdio",
  "pts.step.2": "Espaço",
  "pts.step.3": "Investimento",
  "pts.step.4": "Contacto",
  "pts.step.5": "Necessidades de Equipamento",
  "pts.step.6": "Contacto",
  "pts.opt.role.personal-trainer": "Personal Trainer",
  "pts.opt.role.sc-coach": "Treinador de Força e Condicionamento",
  "pts.opt.role.studio-owner": "Dono de Estúdio",
  "pts.opt.role.investor-entrepreneur": "Investidor / Empreendedor",
  "pts.opt.role.other": "Outro",
  "pts.opt.plan.first-studio": "Abrir o meu primeiro estúdio",
  "pts.opt.plan.upgrade-studio": "Melhorar o meu estúdio atual",
  "pts.opt.plan.another-location": "Abrir outro espaço",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "Preciso de ajuda a escolher",
  "pts.opt.loc.confirmed": "Sim",
  "pts.opt.loc.looking": "Ainda à procura",
  "pts.opt.loc.not-yet": "Ainda não",
  "pts.opt.size.under-50": "Menos de 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Mais de 200 m²",
  "pts.opt.size.undefined": "Ainda não definido",
  "pts.opt.time.1-2": "1–2 meses",
  "pts.opt.time.2-4": "2–4 meses",
  "pts.opt.time.4-6": "4–6 meses",
  "pts.opt.time.6-plus": "Mais de 6 meses",
  "pts.opt.inv.under-10k": "Menos de 10.000",
  "pts.opt.inv.10-20k": "10.000–20.000",
  "pts.opt.inv.20-40k": "20.000–40.000",
  "pts.opt.inv.40-80k": "40.000–80.000",
  "pts.opt.inv.80k-plus": "Mais de USD 80.000",
  "pts.opt.need.complete-studio-equipment": "Equipamento Completo de Estúdio",
  "pts.opt.need.strength": "Máquinas de Musculação",
  "pts.opt.need.functional": "Treino Funcional",
  "pts.opt.need.cardio": "Equipamento de Cardio",
  "pts.opt.need.full-project-help": "Preciso de ajuda com o projeto completo",
  "pts.opt.role.gym-owner-operator": "Dono / Operador de Ginásio",
  "pts.opt.inv.under-20k": "Menos de USD 20.000",
  "pts.opt.inv.20-30k": "USD 20.000–30.000",
  "pts.opt.inv.30-50k": "USD 30.000–50.000",
  "pts.opt.inv.50-80k": "USD 50.000–80.000",
  "err.phoneInvalid": "Introduza um número de telefone válido para o país selecionado.",
};
